// src/common/chart/MonthSalesChart.js
import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getRequest } from "../../apis/ApiInstence";


const MonthSalesChart = () => {

  const [salesData, setSalesData] = useState([]);

  const fetchProducts = async () => {
    try {
      const res = await getRequest('order/monthSalesData');
      console.log('✅ Month-wise sales data fetched successfully:', res?.data?.data);
      setSalesData(res?.data?.data || []);
    } catch (err) {
      console.error('❌ Failed to fetch products:', err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);



  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Month-wise Sales Data",
    },
    subtitle: {
      text: "Sales in INR",
    },
    xAxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Sales (INR)",
      },
    },
    tooltip: {
      headerFormat: "<span style='font-size:10px'>{point.key}</span><table>",
      pointFormat:
        "<tr><td style='color:{series.color};padding:0'>{series.name}: </td>" +
        "<td style='padding:0'><b>₹{point.y}</b></td></tr>",
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Sales",
        data: salesData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default MonthSalesChart;
